<template>
  <loginView v-if="this.$route.path == '/login'" />
  <div class="router" v-else>
    <div class="navheader">
      <img class="icon-48" src="@/assets/logo/studit_weiss.svg" />
      <tt>Analytics</tt>
    </div>
    <aside class="layout-sidenav" v-show="!isCollapsed">
      <div class="navwrapper">
        <ul>
          <li>
            <router-link class="nav_button" to="/">
              <img
                class="icon-24"
                src="@/assets/icons/home_fill.svg"
              />Home</router-link
            >
          </li>
          <li>
            <a class="nav_button" @click="this.categories = !this.categories">
              <img
                class="icon-24"
                src="@/assets/icons/Arrow_down.svg"
                v-show="!categories"
              />
              <img
                class="icon-24"
                src="@/assets/icons/Arrow_up.svg"
                v-show="categories"
              />
              Kategorien
            </a>
            <ul :class="categories ? '' : 'hide'">
              <li><a class="nav_button">Projekte</a></li>
              <li><a class="nav_button">Aktivitäten</a></li>
              <li><a class="nav_button">Techniker</a></li>
              <li><a class="nav_button">Mitarbeiter</a></li>
            </ul>
          </li>
          <li>
            <router-link class="nav_button" to="/myboards">
              <img class="icon-24" src="@/assets/icons/dashboard.svg" />
              Meine Dashboards
            </router-link>
          </li>
        </ul>
      </div>
    </aside>
    <header class="layout-header">
      <img
        class="icon-48"
        src="@/assets/icons/expand_left.svg"
        alt="Close"
        @click="collapsemenu()"
        v-show="isCollapsed"
      />
      <img
        class="icon-48"
        src="@/assets/icons/collapse_left.svg"
        alt="Close"
        @click="collapsemenu()"
        v-show="!isCollapsed"
      />
      <img
        class="icon-48"
        src="@/assets/icons/account_white.svg"
        alt="Close"
        @click="collapseaccount()"
      />
      <ModalClipRight @close="collapseaccount()" v-if="this.ModalAccount">
        <a class="ModalButton"
          ><img src="@/assets/icons/account_white.svg" /><span>Account</span></a
        >
        <a class="ModalButton"
          ><img src="@/assets/icons/settings.svg" /><span>Settings</span></a
        >
        <a class="ModalButton" @click="logout()"
          ><img src="@/assets/icons/account_white.svg" /><span>Logout</span></a
        >
      </ModalClipRight>
    </header>
    <div class="layout-content" :class="isCollapsed ? 'collapsed' : ''">
      <div class="routerviewwrapper">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import loginView from "./views/loginView.vue";
import ModalClipRight from "./components/ModalClipRight.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    loginView,
    ModalClipRight,
  },
  data() {
    return {
      ModalAccount: false,
      isCollapsed: false,
      categories: false,
    };
  },
  created() {},
  methods: {
    collapsemenu() {
      this.isCollapsed = !this.isCollapsed;
    },
    collapseaccount() {
      this.ModalAccount = !this.ModalAccount;
    },
    logout() {
      axios.post("/api/auth/logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style>
:root {
  --primary-fg: #0e0e0e;
  --secondary-fg: #f2275d;
  --primary-bg: #f7f9fd;
  --secondary-bg: #020659;
  --gray-600: #9e9e9e;
  --border: #f3f3f3;
  --box-shadow: #f3f3f3;
  --error: #ff7878;
  --black: #000;
}

* {
  font-family: "Roboto", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  box-sizing: border-box;
}

html,
body {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
}

#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.router {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr 10fr;
}

.hide {
  display: none;
  visibility: hidden;
}

.collapsed {
  grid-column-start: 1 !important;
  grid-column-end: 3 !important;
}

hr {
  background: none;
  border: 1px solid var(--border);
  max-width: 90%;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  background: var(--secondary-bg);
  background-color: #020659;
}

.layout-sidenav {
  grid-column: 1;
  grid-row: 2;
  background: var(--secondary-bg);
}

.layout-content {
  grid-column: 2;
  grid-row: 2;
  height: 100%;
  width: 100%;
  overflow: auto;
}

.layout-header {
  position: relative;
  background: var(--secondary-bg);
  color: white;
  padding: 1rem;
  grid-row: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.routerviewwrapper {
  width: 100%;
  border-radius: 15px 0 0 0;
  background: #fff;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.navheader {
  grid-column: 1;
  grid-row: 1;
  max-height: 100%;
  padding: 1rem;
  display: grid;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  text-align: right;
}

.navheader img {
  width: 150px;
  height: auto;
}

.navwrapper {
  grid-row: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nav_button {
  color: white;
  border-radius: 5px;
  text-decoration: none;
  padding: 10px 25px;
  width: 100%;
  cursor: pointer;
}

.nav_button:hover {
  background: var(--secondary-bg);
  filter: brightness(1.2);
}

.router-link-active {
  background: var(--secondary-bg);
  filter: hue-rotate(0deg) saturate(0.8) brightness(0.9);
  color: white;
}

ul {
  padding: 20px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  list-style-type: none;
}

li {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

li .nav_button {
  display: flex;
  align-items: end;
  justify-content: left;
  gap: 5px;
}

.icon-24 {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.icon-48 {
  height: 48px;
  width: 48px;
  cursor: pointer;
}

.error {
  color: var(--error);
}

tt {
  font-family: monospace;
}

a {
  cursor: pointer;
}

.ModalButton {
  width: 100%;
  padding: 1em 2em;
  color: var(--black);
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: left;
  text-align: left;
}

.ModalButton:hover {
  background: #f0f0f0;
}

.ModalButton img {
  width: 20px;
  fill: var(--black);
  color: #000;
  filter: invert(1);
}
</style>
